import './HeaderNav.scss';
import { useNavigate, useLocation } from "react-router-dom";
function HeaderNav(){
    const navigate = useNavigate();
    const handleClickRedirect = async () => {
        navigate('/');
      };
    return(<>
    <nav className='header-nav-container'>
        <div className='logo-section'>
            <img 
            src='https://logos-world.net/wp-content/uploads/2020/10/Free-Logo.png'
            onClick={() => handleClickRedirect()}
            ></img>
        </div>
    </nav>
    </>)
}
export default HeaderNav;